import { render, staticRenderFns } from "./CourseOrderDetailsComponent.vue?vue&type=template&id=566aa1da&"
import script from "./CourseOrderDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./CourseOrderDetailsComponent.vue?vue&type=script&lang=js&"
import style0 from "./CourseOrderDetailsComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ifrond/srv/civana/reset/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('566aa1da')) {
      api.createRecord('566aa1da', component.options)
    } else {
      api.reload('566aa1da', component.options)
    }
    module.hot.accept("./CourseOrderDetailsComponent.vue?vue&type=template&id=566aa1da&", function () {
      api.rerender('566aa1da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin/components/CourseOrderDetailsComponent.vue"
export default component.exports